

















import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class PercentIcon extends Vue {
  @Prop({ default: '22' }) readonly width?: string;
  @Prop({ default: '22' }) readonly height?: string;
  @Prop({ default: '#405F7A' }) readonly color?: string;
}
